import { Route, Routes } from 'react-router-dom';
import React from 'react';
import { Login } from '../../components/login/login';
import { RequiredAuth } from '../auth/required-auth';
import { DashboardContent } from '../../components/dashboard/dashboard';
import { Approvals } from '../../components/approvals/approvals';
import { RouteNames } from './route-names';
import { LoginCallback } from '@okta/okta-react';
import { MyAccess } from 'components/myaccess/myaccess';
import { Family } from 'components/family/family';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteNames.LOGIN} element={<Login />}></Route>
      <Route path={RouteNames.CALLBACK} element={<LoginCallback />}></Route>
      <Route path="/" Component={RequiredAuth}>
        <Route path="/" element={<DashboardContent />} />
        <Route path={RouteNames.APPROVALS} element={<Approvals />} />
        <Route path={RouteNames.MYACCESS} element={<MyAccess />} />
        <Route path={RouteNames.FAMILY} element={<Family />} />
      </Route>
    </Routes>
  );
};
